import { ReactElement } from 'react';
// Features
//import { SocialShare } from '@utmb/features/layout/social-share/SocialShare';
// Design System
import { Col } from '@utmb/design-system/box/Box';
import { Font } from '@utmb/design-system/text/font';
import { Image } from '@utmb/design-system/image/Image';
import { Link } from '@utmb/design-system/link/link';
import { Pin } from '@utmb/design-system/pin/Pin';
// Types
import { ColorTypesEnum } from '@utmb/types/colors';
import { LinkFollowClassEnum } from '@utmb/types/enum/LinkFollowClassEnum';
import { Slice } from '@utmb/types/slice-handler';
import { SliceBannerHeroView } from '@utmb/types/index';
// Utils
import { parseMarkdown } from '@utmb/utils/markdown';
// Styles
import styles from './hero-banner.module.scss';
import { CloudinaryTransformEnum } from '@utmb/types/cloudinary-transform.enum';
import { ImageFilterEnum } from '@utmb/types/enum/ImageFilterEnum';

export interface HeroBannerProps extends SliceBannerHeroView {
    button?: {
        label: string;
        href: string;
        color: string;
        bgColor: string;
        followClass?: LinkFollowClassEnum;
    };
    ghostButton?: boolean;
}

export const HeroBanner = (props: Slice<HeroBannerProps>): ReactElement => {
    const { id, title, summary, background, thumbnail, button, ghostButton = false, imageFilter } = props;

    return (
        <Col id={id} className={styles.container}>
            <Pin.Cover xy={{ zIndex: -1 }}>
                <Image
                    objectFit="cover"
                    layout="fill"
                    image={background}
                    className={imageFilter === ImageFilterEnum.SIMPLE_ALPHA ? styles.filtered_img : undefined}
                    addOptions={imageFilter === ImageFilterEnum.EPIC ? [CloudinaryTransformEnum.EPIC] : undefined}
                />
            </Pin.Cover>
            {thumbnail && (
                <div className="container">
                    <div className={styles.thumbnail_container}>
                        <Image layout="intrinsic" image={thumbnail} width={thumbnail.width} height={thumbnail.height} />
                    </div>
                    <div className={`${styles.content_container} row`}>
                        <div className="offset-md-6">
                            {title && (
                                <Font.FuturaMedium mobile="32" desktop="32" className={styles.title}>
                                    {title}
                                </Font.FuturaMedium>
                            )}
                            {summary && (
                                <Font.FuturaMedium mobile="16" desktop="18" className={styles.summary} as="div">
                                    <div className="markdown" dangerouslySetInnerHTML={{ __html: parseMarkdown(summary) }} />
                                </Font.FuturaMedium>
                            )}
                            {!ghostButton && button && (
                                <Link.Button
                                    composeClassName={styles.button}
                                    label={button.label}
                                    href={button.href}
                                    followClassName={`${button.followClass}-ga`}
                                    color={ColorTypesEnum.PRIMARY}
                                    bgcolor={ColorTypesEnum.SECONDARY}
                                ></Link.Button>
                            )}
                            {ghostButton && button && (
                                <Link.Default
                                    composeClassName={styles.button}
                                    label={button.label}
                                    href={button.href}
                                    followClassName={`${button.followClass}-ga`}
                                ></Link.Default>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/*<Pin xy={{ top: '50%', right: '30px', transform: 'translateY(-50%)' }}>
                <SocialShare.Vertical className="landscape-only" />
            </Pin>*/}
        </Col>
    );
};
